// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React from "react";
import { useDispatch } from "react-redux";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import { ModuleProvider, useModuleContext } from "../ModuleContext";
import {
  ModuleProvider as ChatModuleProvider,
  useModuleContext as useChatModuleContext,
} from "../../Chat/ModuleContext";
import { AESVG } from "../../../../_emywork/components/svg";
import { AEButton } from "../../../../_emywork/components/buttons";
import { useIntl } from "react-intl";
import { AERating } from "../../../../_emywork/components/rating";
import * as actions from "../_redux/actions";
import { AELabels } from "../../../../_emywork/components/AELabel";
import { AETruncate, localField } from "../../../../_emywork/helpers/UIHelper";
import { AEUserBadge } from "../../../../_emywork/components/AEBadge";
import { AERole } from "../../../../_emywork/components/AERole";
import { roles } from "../../../App";
import {
  AEEmail,
  AELink,
  AEPhone,
} from "../../../../_emywork/components/AELink";
import { CONTEXT } from "../helpers/ModuleHelpers";
import { HTTP_UPDATED } from "../../../../_emywork/helpers/AxiosHelpers";
import { AEAvatar } from "../../../../_emywork/components/AEAvatar";
import { AddToTeamModal } from "../dialogs/addToTeamModal";
import { HireModal } from "../dialogs/hireModal";
import { Dropdown } from "react-bootstrap";
import { DropdownCustomToggler } from "../../../../_metronic/_partials/dropdowns";
import { AddToGroupModal } from "../dialogs/addToGroupModal";
import { DropdownAEToggler } from "../../../../_metronic/_partials/dropdowns/DropdownAEToggler";
import { ROUTE_PREFIX } from "../helpers/RoutingHelpers";

export const EntityCard = (props) => (
  <ModuleProvider>
    <ChatModuleProvider>
      <AddToTeamModal />
      <AddToGroupModal />
      <HireModal />
      <EntityCardContent {...props} />
    </ChatModuleProvider>
  </ModuleProvider>
);

function EntityCardContent({
  entity,
  size = "md",
  onUpdate,
  editAction = false,
  detailsAction = false,
  sendProposalAction = false,
  deleteAction = false,
  chatAction = false,
  className = "",
}) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    openGroupDialog,
    openTeamDialog,
    openHireDialog,
    getDetailsPath,
  } = useModuleContext();
  const { openChat } = useChatModuleContext();
  const {
    rating,
    id,
    username,
    badge,
    about,
    is_saved,
    legal_form,
    skills,
    activity_area,
    function_,
    is_active,
    is_private,
  } = entity;

  const classes = {
    xs: {
      card: "shadow-none ",
      cardBody: "p-0",
      symbol: "symbol-40 mr-2",
      // title: 'font-size-md',
    },
    sm: {
      symbol: "symbol-45 mr-3",
      cardBody: "d-flex justify-content-center",
    },
    md: {
      symbol: "symbol-60 mr-5",
      card: "card-stretch",
      cardBody: "p-3 d-flex flex-column",
      title: "font-size-lg",
    },
    lg: {
      symbol: "symbol-100 mr-5",
      title: "font-size-h3",
    },
  };

  const sizeClasses = classes[size];
  const isLg = size === "lg";
  const isMd = size === "md";
  const isXs = size === "xs";

  let subtitles = [];

  if (activity_area) {
    subtitles.push({
      id: "ACTIVITY_AREA",
      svg: "/Design/Target.svg",
      value: activity_area[localField()],
      showIcon: true,
      showHelperText: true,
    });
  }

  if (function_) {
    subtitles.push({
      id: "FUNCTION",
      svg: "/Code/Settings4.svg",
      value: function_[localField()],
      showIcon: true,
      showHelperText: true,
    });
  }

  if (legal_form) {
    subtitles.push({
      id: "LEGAL_FORM",
      svg: "/Files/Selected-file.svg",
      value: legal_form[localField()],
      showIcon: isLg,
      showHelperText: isLg,
    });
  }


  const AddDropdown = () => (
    // entity.is_private === 0 && (
    <Dropdown>
      <Dropdown.Toggle as={DropdownAEToggler}>
        <AEButton size={"sm"} variant={"white"} fontWeight={"bolder"}>
          <AESVG
            path={"/Communication/Add-user.svg"}
          // size={"lg"}
          />
          {formatMessage({ id: "ADD" })}
        </AEButton>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
        <Dropdown.Item
          onClick={() => {
            openTeamDialog(id);
          }}
        >
          {formatMessage({ id: "ADD_TO_TEAM" })}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            openGroupDialog(id);
          }}
        >
          {formatMessage({ id: "ADD_TO_GROUP" })}
        </Dropdown.Item>
        <AERole accept={[roles.client]}>
          <Dropdown.Item
            onClick={() => {
              openHireDialog(id);
            }}
          >
            {formatMessage({ id: "HIRE" })}
          </Dropdown.Item>
        </AERole>
      </Dropdown.Menu>
    </Dropdown>)
  // );

  return (
    <Card className={`${sizeClasses.card} ${className}`}>
      <CardBody className={`${sizeClasses.cardBody}`}>
        <div className={`d-flex mb-${isLg ? "5" : "0"}`}>
          <AEAvatar entity={entity} className={sizeClasses.symbol} />

          <div
            className={`${isLg ? "flex-grow-1" : "d-flex align-items-center"} `}
          >
            <div className={`d-flex justify-content-between flex-wrap mt-1`}>
              <div className={`${isXs ? "" : "-d-flex align-items-center"}`}>

                <AELink
                  to={getDetailsPath(username)}
                  className={`text-dark-75 text-hover-primary font-weight-bold mr-1 ${sizeClasses.title}`}
                // onClick={openDetailsPageHandler}
                >
                  {username}
                  {/* {entity.is_private === 1 ? username : username} */}
                  {badge && (
                    <>
                      <AEUserBadge
                        id={badge}
                        activationStatus={is_active}
                        size={isXs ? "sm" : size}
                      />
                    </>
                  )}
                  {is_saved && (
                    <AESVG
                      path={"/General/Heart.svg"}
                      variant={is_saved ? "danger" : "light"}
                      size={isXs ? "sm" : size}
                    />
                  )}
                </AELink>
                {subtitles.length > 0 && (
                  <div className="flex-grow-1 pt-1">
                    {subtitles.map((op) => (
                      <div key={op.id} className="d-flex pb-1">
                        {op.showIcon && (
                          <AESVG
                            size={"md"}
                            className={"flex-shrink-0 mr-3"}
                            path={op.svg}
                          />
                        )}

                        <span className="">
                          {op.value}
                          {op.showHelperText && (
                            <span className={"text-muted ml-2"}>
                              {" "}
                              {formatMessage({ id: op.id })}{" "}
                            </span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="my-lg-0 my-3">
                {chatAction &&
                  !isLg && ( //todo
                    <div>
                      <AEButton
                        size={"sm"}
                        variant={"white"}
                        fontWeight={"bolder"}
                        onClick={(event) => {
                          openChat(username);
                        }}
                      >
                        <AESVG
                          path={"/Communication/Chat1.svg"}
                          className={"pr-1"}
                        />
                        {formatMessage({ id: "MESSAGE" })}
                      </AEButton>
                    </div>
                  )}
              </div>

              {isLg && (
                <div className="my-lg-0 my-3">
                  <div>
                    <AEButton
                      size={"sm"}
                      variant={"white"}
                      fontWeight={"bolder"}
                      onClick={(event) => {
                        openChat(username);
                      }}
                    >
                      <AESVG
                        path={"/Communication/Chat1.svg"}
                        className={"pr-1"}
                      />
                      {formatMessage({ id: "MESSAGE" })}
                    </AEButton>
                  </div>
                  <AddDropdown />
                  <AERole accept={[roles.super_admin]}>
                    <AELink to={`${ROUTE_PREFIX}/${entity.username}/edit`}>
                      <AEButton
                        size={"sm"}
                        variant={"white"}
                        fontWeight={"bolder"}
                      >
                        <AESVG path={"/Design/Edit.svg"} className={"pr-1"} />
                        {formatMessage({ id: "EDIT" })}
                      </AEButton>
                    </AELink>
                  </AERole>
                </div>
              )}

              {isMd && <AERating value={rating} className={"w-100"} />}
            </div>
          </div>
        </div>

        {isMd && (
          <div className={"p-2"}>
            <AETruncate text={about} length={200} useWordBoundary />
          </div>
        )}

        {isLg && (
          <>
            <div className="separator separator-solid mb-2" />
            <div className="d-flex align-items-center flex-wrap mt-8">
              {[
                {
                  id: "profile",
                  title: "OVERVIEW",
                  svg: "/Code/Compiling.svg",
                },
                {
                  id: "emy-projects",
                  title: "EMY_PROJECTS",
                  svg: "/Code/Compiling.svg",
                },
                {
                  id: "emy-services",
                  title: "EMY_SERVICES",
                  svg: "/Design/PenAndRuller.svg",
                },
                {
                  id: "emy-products",
                  title: "EMY_PRODUCTS",
                  svg: "/Shopping/Box3.svg",
                },
              ].map((tab) => (
                <div
                  key={tab.id}
                  className="d-flex align-items-center flex-lg-fill mr-5 mb-2"
                >
                  <span className="mr-4">
                    <AESVG path={tab.svg} size={"3x"} />
                  </span>
                  <div className="d-flex flex-column flex-lg-fill">
                    <span className="text-dark-75 font-weight-bolder font-size-sm">
                      {formatMessage({ id: tab.title })}
                    </span>
                    <AELink
                      // to={toAbsoluteUrl(`/${CONTEXT}/${username}/${tab.id}`)}
                      to={`/${CONTEXT}/${username}/${tab.id}`}
                      className="text-primary font-weight-bolder"
                    >
                      {formatMessage({ id: "VIEW" })}
                    </AELink>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {isMd && (
          <div className={"mt-auto"}>
            <div className="separator separator-solid mb-2" />
            <div className="d-flex justify-content-between ">
              <div>
                <AELabels variant={"light"} options={skills} />
              </div>
              <div className="d-flex">
                <AddDropdown />
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

